<template>
    
    <div  class="blog-area ptb-100" >
        <div class="container">
            <div class="row">
                <div class="col-lg-4 col-md-12">
                    <aside class="widget-area left-sidebar">
                        <div class="widget widget_search">
                            <form class="search-form">
                                <label><input type="search" class="search-field" placeholder="Search..."></label>
                                <button type="submit"><i class="ri-search-2-line"></i></button>
                            </form>
                        </div>
                        <div class="widget widget_meander_software_posts_thumb">
                            <h3 class="widget-title">Popular Posts</h3>
                            <article class="item" v-for="(blog) in popularBlogs" :key="blog.id">
                                <router-link :to="`/resource-details/${blog?.slug}`"  class="thumb"><span class="fullimage cover"
                                        :style="{ backgroundImage: 'url(' + $backendUrl + blog.image?.url + ')' }"
                                        role="img"></span></router-link>
                                <div class="info">
                                    <h4 class="title usmall"><router-link :to="`/resource-details/${blog.image?.slug}`" >{{ blog.title
                                    }}</router-link></h4>
                                    <span class="date"><i class="ri-calendar-2-fill"></i>{{
                                        formatDate(blog.publishedAt) }}</span>
                                </div>
                            </article>

                        </div>
                        <div class="widget widget_categories">
                            <h3 class="widget-title">Categories</h3>
                            <ul>
                                <li v-for="(category) in categories" :key="category?.slug">
                                    <router-link :to="{path:'/resources',query:{slug:category?.slug}}" >
                                    <a class="cursor-pointer ">{{ category.name }}
                                        <!-- <span class="post-count">(2)</span> -->
                                    </a>
                                </router-link>
                                </li>
                            </ul>
                        </div>
                       
                    </aside>
                </div>
                <div class="col-lg-8 col-md-12" >
                    <div class="row justify-content-center">
                        <BlogSkleton v-if="isLoading"/>
                        <div v-else class="col-lg-6 col-md-6" v-for="(blog) in blogs" :key="blog?.slug">
                            <div class="single-blog-post">
                                <div class="image">
                                    <router-link :to="`/resource-details/${blog?.slug}`"  class="d-block">
                                        <img style="height:250px;  "  :src="$backendUrl + blog.image?.url" alt="blog">
                                        <!-- <img  :src="blog.blog_img.url" alt="blog"> -->
                                    </router-link>
                                    <!-- <router-link :to="`/resource-details/${blog.attributes.slug}`"  class="tag">{{
                                        blog.attributes.blog_categories.data[0].attributes.name
                                    }}</router-link> -->
                                </div>
                                <div class="content">
                                    <ul class="meta">
                                        <li><i class="ri-time-line"></i> {{ formatDate(blog.publishedAt) }}</li>
                                        <!-- <li><i class="ri-message-2-line"></i> <router-link to="/resource-details">(0) Comment</router-link></li> -->
                                    </ul>
                                    <h3><router-link :to="`/resource-details/${blog?.slug}`" >{{ blog.title }}</router-link></h3>
                                </div>
                            </div>
                        </div>







                        <div class="col-lg-12 col-md-12">
                            <div class="pagination-area">
                                <!-- <div class="nav-links">
                                    <span class="page-numbers current">1</span>
                                    <router-link to="/blog-left-sidebar" class="page-numbers">2</router-link>
                                    <router-link to="/blog-left-sidebar" class="page-numbers">3</router-link>
                                    <router-link to="/blog-left-sidebar" class="next page-numbers" title="Next Page"><i class="ri-arrow-right-line"></i></router-link>
                                </div> -->
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
.activeclass:active{
color: brown;
}
</style>
<script>
import { watchEffect } from "vue";
import { useGetBlogs } from "../../services/graphqlService";

import axios from "axios";
import BlogSkleton from './BlogSkleton.vue'
export default {
    name: 'Blog',
    components: {
            BlogSkleton
                },
    data() {
        return {
            isLoading: true,
            blogs: [],
            categories: [],
            popularBlogs: [],
            currentPage: 1,
            itemsPerPage: 6,
            totalItems: 0,
            totalPages: 0,
        };
    },

    watch: {
    // eslint-disable-next-line no-unused-vars
    '$route.query.slug'(newSlug, oldSlug) {
      this.fetchBlogs();
    },
  },

    methods: {
    fetchBlogs() {
        const slug = this.$route.query.slug;
        let pagination = {
          page: this.currentPage,
          pageSize: this.itemsPerPage,
        }
      // const slug = this.$route.params.slug;
      const { result, onError } = slug ? useGetBlogsByCategory(slug, pagination) : useGetBlogs(pagination);
      watchEffect(() => {
        if (result.value?.meanderSoftwareBlogs?.length) {
        this.blogs = result.value.meanderSoftwareBlogs;

        // Safely handle pagination
        if (result.value?.meanderSoftwareBlogs_connection?.pageInfo) {
            this.totalItems = result.value.meanderSoftwareBlogs_connection.pageInfo.total;
            this.totalPages = result.value.meanderSoftwareBlogs_connection.pageInfo.pageCount;
        }
    } else {
        console.warn("No blogs found.");
    }

        this.isLoading = false
      });

      onError((error) => {
        console.error("Error fetching app by slug:", error);
      });
    },
        async getCategories() {
            const response = await axios.get(`${this.$backendUrl}/api/ms-blog-categories`);
            this.categories = response.data.data;
        },

        async fetchPopularPosts() {
            const response = await axios.get(`${this.$backendUrl}/api/meander-software-blogs?pagination[limit]=5&populate=image`);
            this.popularBlogs = response.data.data;
            
            
        },

        formatDate(date) {
  if (!date) return "N/A"; // Return default text if date is missing
  const options = { year: "numeric", month: "short", day: "2-digit" };
  return new Date(date).toLocaleDateString(undefined, options);
},

        onPageChange(page) {
    if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchBlogs();
    }
},

    },
    mounted: async function () {
        this.fetchBlogs();
              await this.getCategories();
        await this.fetchPopularPosts();
    }

};
</script>